<template>
    <Head title="Download" />

    <div class="font-sans text-gray-900 antialiased">
        <div class="py-4 bg-gray-100">
            <div class="min-h-screen flex flex-col items-center pt-6 sm:pt-0">
                <div>
                    <jet-company-logo />
                </div>

                <div class="w-full sm:max-w-2xl p-6 pb-0 bg-white shadow-md overflow-hidden sm:rounded-lg prose">
                    <div class=" text-center">
                        <img class="d-block mx-auto" src="/img/digitalcat.svg" alt="" width="200" height="153">
                        <h1 class="display-5 fw-bold">{{ product }}</h1>
                        <div class="col-lg-6 mx-auto">
                            <p class="lead mb-4">Your download is ready!</p>
                            <p>If you need any help, please don't hesitate to contact us for assistance.</p>
                            <ul class="list-none">
                                <li>Click on Save to save it</li>
                                <li>Click on Run or double-click the file</li>
                                <li>Follow the prompts in the installation wizard</li>
                            </ul>
                            <p class="mb-4">You may receive a notification that a potentially harmful program has been blocked. You will need to click on either "More Info" or "More Actions" until you are presented with a button that says "Run Anyway" to continue.</p>
                            <div class="d-grid gap-2 d-sm-flex justify-content-sm-center">
                                <jet-button type="button" :href="'/download/start/' + keyString">Download</jet-button>
                            </div>
                        </div>
                        <div class="overflow-hidden" style="max-height: 30vh;">
                            <div class="container px-5">
                                <img src="/img/screenshots/digitalcat.png" class="img-fluid border rounded-3 shadow-lg mb-4" alt="Example image" width="700" height="500" loading="lazy">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue'
import { Head } from '@inertiajs/inertia-vue3';
import JetCompanyLogo from '@/Jetstream/CompanyLogo.vue'
import JetButton from '@/Jetstream/Button.vue'

export default defineComponent({
    props: {
        product: String,
        keyString: String,
    },

    components: {
        Head,
        JetCompanyLogo,
        JetButton,
    },
})
</script>
